module.exports = __webpack_public_path__ + "media/images/front/icon_user-5eb0878bff41a20314b7a46ef2976ca3.png";